import { IApplicationState } from '../../types/redux';

export const selectPageTitle = ({ seoData }: IApplicationState) => {
  return seoData.h1;
};
